// src/utils/initQuestions.js

export async function initQuestions({
  userId,
  email,
  fullName,
  themeName,
  token,
  sessionId,
  organizationId,
  lobby,
  link,
  loginPin,
}) {
  const body = {
    userId,
    email,
    fullName,
    themeName,
    sessionId,
    organizationId,
    lobby,
    link,
    loginPin,
  };
  Object.keys(body).forEach((k) => body[k] === undefined && delete body[k]);

  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/setUserQuestions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!resp.ok) {
    const err = await resp.json();
    throw new Error(err.message || 'Failed to initialize questions');
  }
  return resp.json();
}
